module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/130.985aa655.png";